/**
 * Semantic color buckets shared by the operations surfaces (/admin/ops and
 * /voice/live). Token-only Tailwind classes; the two pages must read the same
 * green/amber/red, so the maps live here rather than per page.
 */

// `info` is the neutral, non-judgmental bucket — a state that is neither good
// nor bad yet (a transfer still on the phone).
export type OpsSem = 'success' | 'warn' | 'danger' | 'muted' | 'info';

export const semText: Record<OpsSem, string> = {
  success: 'text-success',
  warn: 'text-warn',
  danger: 'text-danger',
  muted: 'text-text-3',
  info: 'text-info',
};

export const semDot: Record<OpsSem, string> = {
  success: 'bg-success',
  warn: 'bg-warn',
  danger: 'bg-danger',
  muted: 'bg-text-4',
  info: 'bg-info',
};

// Solid left-bar color for the health tiles (mirrors the mockup's tile::before).
export const semBar: Record<OpsSem, string> = {
  success: 'bg-success',
  warn: 'bg-warn',
  danger: 'bg-danger',
  muted: 'bg-text-4',
  info: 'bg-info',
};

// Soft tinted pill/tag (no border) for the overall-status pill + tile tags.
export const semTag: Record<OpsSem, string> = {
  success: 'text-success bg-success/10',
  warn: 'text-warn bg-warn/10',
  danger: 'text-danger bg-danger/10',
  muted: 'text-text-3 bg-text-4/10',
  info: 'text-info bg-info/10',
};
